<script lang="ts">
    import { getContext } from 'svelte'
    import type { Readable } from 'svelte/store'

    import type { GenOrder } from '../order'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch } from 'hydria/services/session'
    import type { SimpleFetchResult } from 'hydria/services/session'

    const orderId = getContext('orderId') as Readable<string>
    const Order = getContext('Order') as GenOrder

    let finalToReadyPreCheck = $state(false)
    let working = $state(false)

    async function bringBack() {
        working = true
        let r: SimpleFetchResult

        try {
            r = await simpleFetch('POST', `/json/ecom/1/order/${$orderId}/final-to-ready`)
        } catch (e: any) {
            r = e
            console.error('Failed to bring back from final state:', e)
            notify({
                type: 'danger',
                title: 'Commande',
                text: 'La commande n’a pas pu être ramenée en “ready”' + (e && e.data && e.data.error ? ` : ${e.data.error}` : '.'),
            })
        }

        if (r && r.data) {
            Order.loadGenericResponse(r.data)
        }
        working = false
    }
</script>

<div class="card">
    <div class="card-title" class:text-primary={!finalToReadyPreCheck} class:text-danger={finalToReadyPreCheck}>Ramener en ready/unpaid</div>
    <div class="card-body">
        {#if working}
            <p><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Un moment…</p>
        {:else if !finalToReadyPreCheck}
            <p><button type="button" class="btn btn-outline-secondary" onclick={() => (finalToReadyPreCheck = true)}>Remettre en ready ou unpaid</button></p>
        {:else}
            <p><button type="button" class="btn btn-outline-secondary" onclick={() => (finalToReadyPreCheck = false)}>Annuler</button></p>

            <p><button type="button" class="btn btn-danger" onclick={() => bringBack()}>Confirmer</button></p>
        {/if}
    </div>
</div>
